import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import * as stylex from '@stylexjs/stylex';
import '@astryxdesign/core/theme/tokens.stylex';
import { colorVars, radiusVars, spacingVars } from '@astryxdesign/core/theme/tokens.stylex';
import { Banner } from '@astryxdesign/core/Banner';
import { Button } from '@astryxdesign/core/Button';
import { HStack } from '@astryxdesign/core/HStack';
import { Spinner } from '@astryxdesign/core/Spinner';
import { Text } from '@astryxdesign/core/Text';
import { VStack } from '@astryxdesign/core/VStack';
import { useMediaQuery } from '@astryxdesign/core/hooks';
import { mobileQuery } from '../../app/layout';
import { useTelegramActions, useTelegramStatus } from '../../api/telegram';
export function ConnectBot({
  onLinked
}: {
  onLinked: () => void;
}) {
  const intl = useIntl();
  const mobile = useMediaQuery(mobileQuery);
  const actions = useTelegramActions();
  const status = useTelegramStatus({
    refetchInterval: 3000
  });
  const {
    mutate: requestLink
  } = actions.link;
  useEffect(() => {
    requestLink();
  }, [requestLink]);
  const [initial, setInitial] = useState<string | null | undefined>(undefined);
  useEffect(() => {
    if (initial === undefined && status.data) setInitial(status.data.link?.linkedAt ?? null);
  }, [initial, status.data]);
  const link = status.data?.link;
  const linked = Boolean(link && !link.blocked && initial !== undefined && link.linkedAt !== initial);
  useEffect(() => {
    if (linked) onLinked();
  }, [linked, onLinked]);
  const data = actions.link.data;
  const expired = data ? Date.parse(data.expiresAt) < Date.now() : false;
  return <VStack gap={4}>
      <Text>{intl.formatMessage({
        id: 'notifications.connect.intro'
      })}</Text>
      <ol className="x1ghz6dp x3yw8vx x1blguxw xv1l7n4">
        <li>
          <Text>{intl.formatMessage({
            id: 'notifications.connect.step1'
          })}</Text>
        </li>
        <li>
          <Text>{intl.formatMessage({
            id: 'notifications.connect.step2'
          })}</Text>
        </li>
        <li>
          <Text>{intl.formatMessage({
            id: 'notifications.connect.step3'
          })}</Text>
        </li>
      </ol>
      {actions.link.isError ? <Banner status="error" title={intl.formatMessage({
      id: 'notifications.connect.failed'
    })} collapsible={false} /> : null}
      {data ? <HStack gap={4} wrap="wrap" vAlign="center">
          {!mobile ? <div role="img" aria-label={intl.formatMessage({
        id: 'notifications.connect.qr'
      })} className="xctrb1h xekxv85 xlsj2fj xh6dtrn x1c5tqo3 x2lah0s" dangerouslySetInnerHTML={{
        __html: data.qrSvg
      }} /> : null}
          <VStack gap={2}>
            <Button label={intl.formatMessage({
          id: 'notifications.connect.open'
        }, {
          bot: `@${data.botUsername}`
        })} variant="primary" href={data.url} target="_blank" rel="noopener noreferrer" />
            {!mobile ? <Text size="sm" color="secondary">
                {intl.formatMessage({
            id: 'notifications.connect.qrHint'
          })}
              </Text> : null}
            {expired ? <Button label={intl.formatMessage({
          id: 'notifications.connect.renew'
        })} size="sm" variant="ghost" onClick={() => requestLink()} /> : null}
          </VStack>
        </HStack> : actions.link.isPending ? <Spinner size="md" /> : null}
      <HStack gap={2} vAlign="center">
        <Spinner size="sm" />
        <Text size="sm" color="secondary">
          {intl.formatMessage({
          id: 'notifications.connect.waiting'
        })}
        </Text>
      </HStack>
    </VStack>;
}